import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/$id/companies")({})
